module.exports = __webpack_public_path__ + "static/media/phila_avocado.bcdbcb94.webp";